// MYUS gallery interactions

document.addEventListener('DOMContentLoaded', function () {

// --- PDP detail accordions ---
document.querySelectorAll('.pdp-detail-section').forEach(function (section) {
var label = section.querySelector('.pdp-detail-label');
if (!label) return;
label.addEventListener('click', function () {
section.classList.toggle('is-open');
    });
  });

// --- Look grid: inject "Look N" labels + link each image to its detail page ---
// Skip pages that handle their own labels and linking (hover grids with front + rear images)
var path = window.location.pathname;
var isOdeToASwan = path.indexOf('ode-to-a-swan') > -1;
var isBehindTheWallpaper = path.indexOf('behind-the-wallpaper') > -1;

if (!isOdeToASwan && !isBehindTheWallpaper) {
  document.querySelectorAll('.image-grid').forEach(function (grid) {

    // Derive the collection slug from the current page filename
    var slug = path
          .split('/').pop()
          .replace('-looks.html', '')
          .replace('-looks', '');

    grid.querySelectorAll('img').forEach(function (img, i) {
      // Wrap in figure
      var fig = document.createElement('figure');
      img.parentNode.insertBefore(fig, img);
      fig.appendChild(img);

      // Look label — use paired numbers for It's A Jungle (2 images per look)
      var cap = document.createElement('figcaption');
      var isJungle = path.indexOf('its-a-jungle-out-there') > -1;
      var displayNum = isJungle ? Math.ceil((i + 1) / 2) : (i + 1);
      cap.textContent = 'Look ' + displayNum;
      fig.appendChild(cap);

      // Link image to detail page
      img.style.cursor = 'pointer';
      img.addEventListener('click', function () {
        window.location.href = slug + '-look-' + (i + 1) + '.html';
      });
    });
  });
}

});
